import {useContext, useMemo} from 'react';
import {FilterPreview} from './FilterPreview/FilterPreview';
import {IMAGE_FILTERS} from '~/CreateFabricInvitation/hooks/useImageFilter';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';

interface Canvas {
  getActiveObject: () => any;
}

let unmodifiedActiveObjectSrc = '';

export const ImageFilters = () => {
  const {canvas}: {canvas: Canvas | null} = useContext(EventCreateContext);

  const activeObject = (canvas as unknown as Canvas)?.getActiveObject();
  const activeObjectSrc = useMemo(() => {
    if (!activeObject?.filter?.length) {
      unmodifiedActiveObjectSrc =
        // eslint-disable-next-line no-underscore-dangle
        activeObject?.canvas?._activeObject?._originalElement?.src ||
        // eslint-disable-next-line no-underscore-dangle
        activeObject?.canvas?._activeObject?.src ||
        // eslint-disable-next-line no-underscore-dangle
        activeObject?.canvas?._activeObject?.srcUrl;
      return unmodifiedActiveObjectSrc;
    }

    return unmodifiedActiveObjectSrc;
  }, [activeObject]);

  const photoPreview = Object.entries(IMAGE_FILTERS).map(([key, value]) => ({
    id: crypto.randomUUID(),
    src: activeObjectSrc as string,
    label: value.label,
    filterKey: key,
    cssFilter: value.cssFilter,
  }));

  return <FilterPreview photos={photoPreview} key={crypto.randomUUID()} />;
};
